export default __webpack_public_path__ + "static/media/car.icon.bd596dcc.svg";